import { Head } from '@inertiajs/react';
import { CronJobsCard } from '@/components/cron/cron-jobs-card';
import type { AdminCronJobsShow } from '@/types';

export default function Show({
  title,
  eventSlug,
  eventName,
  eventSpecificJobs,
  generalizedJobs,
}: AdminCronJobsShow) {
  return (
    <>
      <Head title={title} />
      <div className="container mx-auto space-y-6 py-8">
        <div>
          <h1 className="font-bold text-3xl tracking-tight">Cron Jobs</h1>
          <p className="text-muted-foreground">
            Jobs scoped to {eventName}. Global jobs live under the general Cron
            Jobs page.
          </p>
        </div>

        <CronJobsCard
          title="Event-Specific Jobs"
          description={`Jobs hardcoded to ${eventName} — they only ever act on this edition.`}
          jobs={eventSpecificJobs}
          eventSlug={eventSlug}
          emptyMessage="No event-specific jobs for this event"
        />

        <CronJobsCard
          title="Event-Generalized Jobs"
          description={`Reusable jobs — running one here targets ${eventName}.`}
          jobs={generalizedJobs}
          eventSlug={eventSlug}
          emptyMessage="No event-generalized jobs configured"
        />
      </div>
    </>
  );
}
